import { DeliveryContent } from 'api/models/Deliveries';
import { useLanguage } from 'context/AppContext';

export type DeliveryContentOption = {
  id: DeliveryContent;
  label: string;
};

const DELIVERY_CONTENTS_OPTIONS = [
  DeliveryContent.Instruments,
  DeliveryContent.Implants,
  DeliveryContent.InstrumentsAndImplants,
  DeliveryContent.Default,
];

export const useDeliveryContentsOptions = () => {
  const lang = useLanguage()[0].DeliveryContent;

  return DELIVERY_CONTENTS_OPTIONS.map<DeliveryContentOption>(content => ({
    id: content,
    label: lang[content],
  }));
};
